import React, { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { UserContext } from "@/components/User";
import { isProduction } from "@/core/environments";
import { Flex } from "@/eworkitComponents";
import { router } from "@/views/router";

import { RouteNavItem } from "./RouteNavItem";

interface INavigationDesktopProps {}

export const NavigationDesktop: FC<INavigationDesktopProps> = () => {
  const { t } = useTranslation("session");
  const User = useContext(UserContext);

  const baseClass = "navigation";

  const dashboardRoute = router.get("dashboard");
  const jobRequestsRoute = router.get("job-requests");
  const jobApplicationsRoute = router.get("job-applications");
  const timeReportsRoute = router.get("time-reports");
  const assignmentsRoute = router.get("assignments");

  return (
    <Flex className={baseClass} direction="row" align="center" justify="flex-start" innerMargin="md">
      <RouteNavItem
        variant="text"
        text={t("COMPONENTS.TOPBAR.BUTTON_DASHBOARD")}
        path={dashboardRoute.path}
        exact={false}
        testName={dashboardRoute.testName}
      />

      <RouteNavItem
        variant="text"
        text={t("COMPONENTS.TOPBAR.BUTTON_JOB_REQUESTS")}
        path={jobRequestsRoute.path}
        exact={false}
        testName={jobRequestsRoute.testName}
      />

      <RouteNavItem
        variant="text"
        text={t("COMPONENTS.TOPBAR.BUTTON_APPLICATIONS")}
        path={jobApplicationsRoute.path}
        exact={false}
        testName={jobApplicationsRoute.testName}
      />

      {!isProduction && User.contextCompany && (
        <RouteNavItem
          variant="text"
          text={t("COMPONENTS.TOPBAR.BUTTON_TIME_REPORTS")}
          path={timeReportsRoute.path}
          exact={false}
          testName={timeReportsRoute.testName}
        />
      )}

      {User.hasRouteAccess(assignmentsRoute) && (
        <RouteNavItem
          variant="text"
          text={t("COMPONENTS.TOPBAR.BUTTON_ASSIGNMENTS")}
          path={assignmentsRoute.path}
          exact={false}
          testName={assignmentsRoute.testName}
        />
      )}
    </Flex>
  );
};
